import type { BeneficialOwnerData, BeneficialOwnerResponse } from '@gcv/shared';
import { useMutation, useQueryClient } from '@tanstack/react-query';

import { BeneficialOwnerApi } from 'api';
import { BANK_BENEFICIAL_OWNERS_KEY } from 'tanstack-hooks/keys';

export function useBankUpdateBeneficialOwner(bankId: string, dispensaryId: string) {
  const beneficialOwnerApi = new BeneficialOwnerApi();
  const queryClient = useQueryClient();

  const { mutate: updateBeneficialOwner, isPending: isUpdatingBeneficialOwner } = useMutation({
    mutationKey: [BANK_BENEFICIAL_OWNERS_KEY, bankId, dispensaryId],
    mutationFn: ({
      beneficialOwnerId,
      beneficialOwner
    }: {
      beneficialOwnerId: string;
      beneficialOwner: BeneficialOwnerData;
    }) =>
      beneficialOwnerApi.bankUpdateBeneficialOwner(bankId, dispensaryId, beneficialOwnerId, beneficialOwner),
    onSuccess: (updatedOwner) => {
      return queryClient.setQueryData(
        [BANK_BENEFICIAL_OWNERS_KEY, bankId, dispensaryId],
        (old: BeneficialOwnerResponse[] | undefined) =>
          old?.map((owner) => (owner.id === updatedOwner.id ? updatedOwner : owner))
      );
    },
    meta: {
      snackbarSuccessMessage: 'Beneficial owner updated successfully.',
      snackbarErrorMessage: 'There was an issue updating beneficial owner.'
    }
  });

  return { updateBeneficialOwner, isUpdatingBeneficialOwner };
}
